import {Icon, Pill} from '@wandb/components';
import type {StructuredPatch} from 'diff';
import React from 'react';

import {
  getFileName,
  getNewFileName,
  getOldFileName,
  isAddedFile,
  isDeletedFile,
  isRenamedFile,
} from './patchFileUtils';

type PatchNameProps = {
  patch: StructuredPatch;
};
export function PatchName({patch}: PatchNameProps) {
  // git add <file> produces a patch with the old file name is /dev/null
  if (isAddedFile(patch)) {
    return (
      <>
        <Pill textValue="ADDED" color="green" />
        {getFileName(patch)}
      </>
    );
  }

  // git rm <file> produces a patch with the new file name is /dev/null
  if (isDeletedFile(patch)) {
    return (
      <>
        <Pill textValue="DELETED" color="red" />
        {getFileName(patch)}
      </>
    );
  }

  // if the old file name and the new file name are different, then this is a
  // rename or move operation
  if (isRenamedFile(patch)) {
    return (
      <>
        <Pill textValue="RENAMED" color="teal" />
        {getOldFileName(patch)}
        <Icon icon="chevron-next" size="sm" />
        {getNewFileName(patch)}
      </>
    );
  }

  // Otherwise no operation was performed, so no badge
  return <>{getFileName(patch)}</>;
}
